<ng-container *transloco="let t">
  <div class="mt-3 h-full">
    <IDataTable [datasource]="dataSource" *transloco="let t">
      <div iDataTableSuffix class="flex items-center gap-2">
        @if (selectedRows().size > 0) {
          <button iButton variant="destructive" (click)="deleteProductGroupsSelection()">
            <IIcon name="trash" />
            {{ t("common.delete_x", { count: selectedRows().size }) }}
          </button>
        }
        <button iButton (click)="createProductGroup()" [disabled]="isReadOnly()">
          <IIcon name="add" />
          {{ t("product-group.new_product_group") }}
        </button>

        <button iButton variant="secondary" size="icon-sm" [iDropdownMenuTrigger]="dropdownMenu" placement="bottom-end">
          <IIcon name="ellipsis" />
        </button>

        <ng-template #dropdownMenu>
          <IDropdownMenu>
            @if (!isReadOnly()) {
              <button iDropdownMenuItem (click)="uploadProductGroups()">
                <IIcon name="import" />
                {{ t("common.import") }}
              </button>
            }
            <button iDropdownMenuItem (click)="exportProductGroups()">
              <IIcon name="export" />
              {{ t("common.export") }}
            </button>
          </IDropdownMenu>
        </ng-template>
      </div>
      <table iTable>
        <thead iTableHead>
          <tr iTableRow>
            <th iTableTh>
              {{ t("common.product_group") }}
            </th>
            <th iTableTh>
              {{ t("common.products") }}
            </th>
            <th iTableTh></th>
          </tr>
        </thead>
        <tbody>
          @for (pg of dataSource.data(); track pg.productGroupId) {
            <tr
              iTableRow
              app-product-group-row
              class="cursor-pointer"
              [productGroup]="pg"
              [accountMarketplace]="accountMarketplace()"
              [isRowSelected]="selectedRows().has(pg)"
              [ngClass]="{ 'bg-main-50 hover:!bg-main-50': selectedRows().has(pg) }"
              [isReadOnly]="isReadOnly()"
              (isRowSelectedChange)="onRowCheckboxClicked(pg)"
              (click)="openProductGroupPage(pg)"
            ></tr>
          } @empty {
            <tr class="text-center text-sm text-gray-400">
              <td colspan="4" class="h-18">{{ t("product-group.no_product_group_found") }}</td>
            </tr>
          }
        </tbody>
      </table>
    </IDataTable>
  </div>
</ng-container>
